import { Content } from './ContentProvider';

export const VIEW_MODES = {
  PDF: 'pdf',
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

const pdfDigitalElements = ['button', 'document', 'video', 'website', 'network'];

export const isDigitalElement = (block) => pdfDigitalElements?.includes(block?.type);

export const makeFilterFn = (content, viewMode) => {
  const getVisibility = (id) => {
    if (viewMode === VIEW_MODES.EDITOR) return true;
    const block = Content.get({ content }, id);
    const media = Content.getMedia({ content }, id);
    const { pdfDigitalElements: status = 'show' } = content?.root;
    const hideDigitalBlock = isDigitalElement(block) && status === 'hide' && !media?.pdf?.ignoreConfig;
    if (viewMode === VIEW_MODES.PDF && (media?.pdf?.isHidden || hideDigitalBlock)) {
      return false;
    }
    if (viewMode === VIEW_MODES.MOBILE && media?.mobile?.isHidden) return false;
    return true;
  };

  const filterChildren = (children = []) =>
    children.filter((child) => {
      if (!getVisibility(child.id)) return false;

      const block = Content.get({ content }, child.id);
      if (block?.children?.length) {
        return filterChildren(block.children).length > 0;
      }

      return true;
    });

  return { getVisibility, filterChildren };
};

export const getChildrenLayout = (content, viewMode, globalSettings) => {
  if (!content) {
    return {};
  }
  const { getVisibility, filterChildren } = makeFilterFn(content, viewMode, globalSettings);
  const childrenLayout = {};

  for (const section of content.sections || []) {
    if (!getVisibility(section.id)) continue;

    childrenLayout[section.id] = filterChildren(section.children);

    Content.traverseDescendants({ content }, section.id, (block) => {
      if (!block.children) return;
      childrenLayout[block.id] = filterChildren(block.children);
    });
  }

  return childrenLayout;
};
